module.exports = __webpack_public_path__ + "static/media/main idea.cd96973c.mp3";